import { useState } from 'react';
import { Button } from '@/components/ui/button';
import api from '@/lib/api';
import { toast } from 'sonner';

const tags = [
  { emoji: '\u{1F4A1}', label: 'Idea contenuto' },
  { emoji: '\u{1F464}', label: 'Nuovo contatto' },
  { emoji: '\u{1F4CB}', label: 'Task operativa' },
  { emoji: '\u{1F4AC}', label: 'Nota per Strategist' },
];

export function QuickCaptureModal({ isOpen, onClose }) {
  const [selectedTag, setSelectedTag] = useState(null);
  const [text, setText] = useState('');
  const [sending, setSending] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (!text.trim()) return;
    setSending(true);
    try {
      await api.post('/operator/quick-capture', {
        text: text.trim(),
        tag: selectedTag,
      });
      toast.success('Cattura inviata all\'Operator');
      setText('');
      setSelectedTag(null);
      onClose();
    } catch {
      toast.error('Errore invio cattura');
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      data-testid="quick-capture-overlay"
    >
      <div className="w-[520px] rounded-2xl bg-white p-[22px]" onClick={e => e.stopPropagation()}>
        <h2 className="mb-4 text-[16px] font-bold text-gray-900" data-testid="quick-capture-title">
          Cattura rapida
        </h2>

        <textarea
          value={text}
          onChange={e => setText(e.target.value)}
          placeholder="Scrivi un'idea, un appunto, una richiesta... L'Operator la analizzer\u00E0 e suggerir\u00E0 come procedere."
          className="mb-4 h-[100px] w-full resize-none rounded-[10px] border border-gray-200 p-3 text-[14px] text-gray-900 placeholder:text-gray-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
          data-testid="quick-capture-text"
        />

        <div className="mb-6 flex flex-wrap gap-2" data-testid="quick-capture-tags">
          {tags.map(tag => (
            <button
              key={tag.label}
              onClick={() => setSelectedTag(selectedTag === tag.label ? null : tag.label)}
              className="rounded-lg border px-3 py-1.5 text-[11px] transition-colors"
              style={{
                borderColor: selectedTag === tag.label ? '#2563EB' : '#E5E7EB',
                backgroundColor: selectedTag === tag.label ? '#EFF6FF' : 'transparent',
                color: selectedTag === tag.label ? '#2563EB' : '#374151',
              }}
              data-testid={`tag-${tag.label.replace(/\s/g, '-').toLowerCase()}`}
            >
              {tag.emoji} {tag.label}
            </button>
          ))}
        </div>

        <div className="flex justify-end gap-3">
          <Button variant="outline" onClick={onClose} className="text-gray-500" data-testid="capture-cancel">
            Annulla
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={!text.trim() || sending}
            className="bg-[#2563EB] font-bold text-white hover:bg-[#1D4ED8]"
            data-testid="capture-submit"
          >
            Invia all'Operator \u2192
          </Button>
        </div>
      </div>
    </div>
  );
}
